// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog[data-v-ddef062a]{padding:0 0 20px}.dialog__form[data-v-ddef062a]{padding:10px 0;margin-top:1.5rem;display:block}.dialog__form>span[data-v-ddef062a]{flex-grow:1}", ""]);
// Exports
module.exports = exports;
